import React from "react";

import TaxesDataTable from "./TaxesDataTable";
import { EnumWrapper } from "../../../../utils/enums";
import { LANGUAGE_CODES } from "../../../../utils/enums/enums";

const TaxesPage = () => {
    return (
        <div className="sub-content">
            <EnumWrapper showLoading={false} enum={LANGUAGE_CODES}>
                <TaxesDataTable/>
            </EnumWrapper>
        </div>
    );
};

export default TaxesPage;


// WEBPACK FOOTER //
// ./src/components/dashboard/admin/taxes/TaxesPage.js